import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BlankLayout = ({ children }) => {

  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        // style={{
        //   width: '100%',
        //   maxWidth: '600px',
        //   padding: '0 15px'
        // }}
      />

      <div className="blank-layout">
        {children}
      </div>
    </>
  );
};

export default BlankLayout;
